
let moment = require('moment');

$(function () {
  "use strict";
    // Remove variable on page load
    const itemRemoves = ['reglement_date',
        'start_date_reglements', 'end_date_reglements', 'current_page']
    itemRemoves.forEach(key => localStorage.removeItem(key));

    // Set default value
    localStorage.reglement_date = '3-last-month';
    localStorage.current_page = 1;

    // Initialisation daterangepicker "Date des soins"
    $('input#daterange').daterangepicker({
      "linkedCalendars": false,
      "autoUpdateInput": false,
      "showCustomRangeLabel": false,
      "showDropdowns": true,
      "opens": "center",
      "maxDate": moment().format("DD/MM/YYYY"),
      "locale": {
          "format": "DD/MM/YYYY",
          "separator": " - ",
          "applyLabel": "Valider",
          "cancelLabel": "Annuler",
          "fromLabel": "Du",
          "toLabel": "au",
          "customRangeLabel": "Custom",
          "weekLabel": "W",
          "daysOfWeek": [
              "Dim",
              "Lun",
              "Mar",
              "Mer",
              "Jeu",
              "Ven",
              "Sa"
          ],
          "monthNames": [
              "Janvier",
              "Février",
              "Mars",
              "Avril",
              "Mai",
              "Juin",
              "Juillet",
              "Août",
              "Septembre",
              "Octobre",
              "Novembre",
              "Decembre"
          ],
          "firstDay": 1
      },
    }, function(start, end, label) {
      const dateRangeElem = $('input#daterange');
      dateRangeElem.val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
      $('input#daterange-hidden').val('1');

      ajaxReglementRequest(dateRangeElem, true, 'form');
    });

    // On form change force auto submit form
    $('form#filter-form').on('change paste', 'input, select, textarea', function(){
        $('form#filter-form').submit();
    });

    // Launch "ajaxReglementRequest" to update data
    $('form#filter-form').submit(function(event) {
        event.preventDefault();

        //reset current page
        localStorage.current_page = 1;

        let self = event.target;
        ajaxReglementRequest(self, true, 'form');
    });

    // Hide PDF modal on click cross
    $(document).on('click touch', '#close-pdf', function() {
        $('#file-download').hide();
    })
    // Colapse or uncolapse row table reglement
    .on('click touch keydown', '.reglement-remboursement-container .reglement-row .reglement-container', function(event) {
        // Filtrer les événements pour le clavier
        if (event.type === 'keydown') {
          // Activer uniquement pour "Enter" ou "Space"
          if (event.key !== 'Enter' && event.key !== ' ') {
            // Ignorer les autres touches
            return;
          }
          // Empêcher le comportement par défaut de "Space" (scroll de la page)
          event.preventDefault();
        }

        let isActive = $(this).parent().hasClass('active');
        let closestPar = $(this).closest('.reglement-remboursement-container');

        //SlideUp & SlideDown details reglements
        closestPar.find('.reglement-row .remboursement-container').slideUp();
        if(isActive)
            $(this).siblings('.remboursement-container').slideUp();
        else
            $(this).siblings('.remboursement-container').slideDown();

        //Add & Remove class "active" on active reglement
        closestPar.find('.reglement-row').removeClass('active');
        if(isActive)
            $(this).parent().removeClass('active');
        else
            $(this).parent().addClass('active');
    })
    // On click date filter set active & launch "ajaxReglementRequest"
    .on('click touch', 'button.button-ajax', function(event) {
        let self = event.target;

        // Set date value filter
        localStorage.reglement_date = $(self).data('date');

        //reset current page
        localStorage.current_page = 1;

        $(self).closest('ul').find('button').removeClass('active');
        $(self).addClass('active');

        ajaxReglementRequest(self, false, 'date');
    })
    // On click PDF link open modal & launch request to get PDF & auto download
    .on('click touch', '.print-pdf', function(event) {
        let self = event.target;
        let current_url = window.location;
        let cont_args = current_url.pathname.split('/')[2];
        let pdf_link = window.location.origin + "/pdf-remboursements/" + cont_args;

        if(pdf_link != null) {
            //Loader during charging pdf
            $('#file-download > .inner')
                .empty()
                .append('<div class="lds-ring">' +
                    '<div></div>' +
                    '<div></div>' +
                    '<div></div>' +
                    '</div>' +
                    '<div class="text">Téléchargement en cours ...</div>').parent().show();
            //Request to get blob data pdf
            $.ajax(pdf_link, {
                type: 'POST',
                data: getValuesFilterPdf(self),  // Data to submit
                xhr:function() { // Seems like the only way to get access to the xhr object
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob'
                    return xhr;
                },
                success : function (data) { // Success message display in modal & auto download pdf
                    let blob = data
                    if(blob.type == 'application/pdf') {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = 'Mes-Remboursements.pdf';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        $('#file-download > .inner')
                            .empty()
                            .addClass('sucess')
                            .append('<img width="40" src="/themes/custom/asaf_afps/images/icons/check_icon.svg" alt="OK"/>'+
                                '<div class="text">Votre bordereau de prestations<br role="presentation"/>a été téléchargé avec succès !</div>' +
                                '<button class="fermer" id="close-pdf">fermer</button>');

                    } else {
                        $('#file-download > .inner')
                            .empty()
                            .addClass('error')
                            .append('<img width="40" src="/themes/custom/asaf_afps/images/icons/error.svg" alt="KO"/>'+
                                '<div class="text">Une erreur est survenur lors du téléchagement,<br role="presentation"/>' +
                                'veuillez réessayer plus tard.</div>' +
                                '<button class="fermer" id="close-pdf">fermer</button>');
                    }
                },
                error : function (data) { // Error message display in modal
                    $('#file-download > .inner')
                        .empty()
                        .addClass('error')
                        .append('<img width="40" src="/themes/custom/asaf_afps/images/icons/error.svg" alt="KO"/>'+
                            '<div class="text">Une erreur est survenur lors du téléchagement,<br role="presentation"/>' +
                            'veuillez réessayer plus tard.</div>' +
                            '<button class="fermer" id="close-pdf">fermer</button>');
                }
            });
        }
    })
    // Pagination for reglement table
    .on('click touch', '.pagination li', function(event){
        let id = $(this).data('id'),
            current_page = parseInt(localStorage.current_page) ? parseInt(localStorage.current_page) : 1;
        if(id) {
            switch(id) {
                case 'p':
                    current_page--;
                    break;

                case 'n':
                    current_page++;
                    break;

                default:
                    current_page = parseInt(id);
                    break;
            }

            if(current_page > 0) {
                $(this).parent().find('li[data-id="' + current_page + '"]').addClass('active');
                localStorage.current_page = parseInt(current_page);
            }
        }

        ajaxReglementRequest(self, true, 'pagination');
    });

    /**
     * Launch request for display data in table
     *
     * @param {*} self
     * @param {*} isForm
     */
    function ajaxReglementRequest(self, isForm, typeEvent) {
        if(isForm) {
            $('.dates-container').find('button.button-ajax').removeClass('active');
            $('.dates-container').find('button.button-ajax').last().addClass('active');

            // Set date value filter
            localStorage.reglement_date = 'all';
        }

        let values = getValuesFilter(self, isForm);

        // Defined is ajax request
        values['isAjax'] = true;

        // Defined type of event
        values['typeEvent'] = typeEvent ? typeEvent : 'form';

        // Get current_page value
        values['currentPage'] = localStorage.current_page;

        // Active loader
        $('.container-table').addClass('active');

        // Request to get new data
        $.ajax(window.location.origin + window.location.pathname, {
            type: 'POST',
            data: values,  // Data to submit
            success : function (data) {
                $('.container-table').removeClass('active'); // Remove Loader
                $('#wrapper-table').replaceWith(data); // Replace data in table element
                if(typeEvent == 'pagination') {
                    window.scrollTo({
                        top: 100,
                        behavior: 'smooth',
                    })
                }

                // Authorization to download "PDF Bordereau", if date interval less than 3 months (~91 days)
                if (( values['date'] == 'all' && !('start_date_reglements' in values) && !('end_date_reglements' in values) ) ||
                    daysdifference( values['start_date_reglements'], values['end_date_reglements']) > 91
                ) {
                    $('#download-pdf .label').addClass('hidden');
                    $('#download-pdf .download-pdf').addClass('hidden');
                    $('#download-pdf .not-download-pdf').removeClass('hidden');
                } else {
                    $('#download-pdf .label').removeClass('hidden');
                    $('#download-pdf .download-pdf').removeClass('hidden');
                    $('#download-pdf .not-download-pdf').addClass('hidden');
                }
            },
            error : function (data) {
                $('.container-table').removeClass('active'); // Remove loader
            }
        });
    }

    /**
     * Get all filter values for request
     *
     * @param {*} self
     * @param {*} isForm
     */
    function getValuesFilter(self, isForm) {
        let values = {};
        let form = $('form#filter-form');
        let formData = form.serializeArray();
        let dateField = $('#daterange');

        if(isForm) {
            formData.forEach((item, index, arr) => {
                switch (item.name) {
                    case 'reglements':
                        if(item.value == '1') {
                            values['start_date_reglements'] = dateField.data('daterangepicker').startDate.format('DD-MM-YYYY');
                            values['end_date_reglements'] = dateField.data('daterangepicker').endDate.format('DD-MM-YYYY');
                        }
                        break;
                    default:
                        values[item.name] = item.value;
                        break;
                }
            }, values);
        } else {
            form.get(0).reset(); //Reset form data
            $('input#daterange-hidden').val(''); // Reset hidden input daterange picker
            $('input#daterange').val("Période des réglements"); //Reset daterange picker
        }

        values['date'] = localStorage.reglement_date ? localStorage.reglement_date : 'all';

        return values;
    }

    /**
     * Get all filter values for request PDF
     *
     * @param {*} self
     * @param {*} isForm
     */
    function getValuesFilterPdf(self) {
        let values = {};
        values['assure'] = self.dataset.assure;
        values['start_date_reglements'] = self.dataset.startDate;
        values['end_date_reglements']   = self.dataset.endDate;
        values['date'] = 'all';

        return values;
    }

    function daysdifference(firstDate, secondDate){
        if( firstDate !== undefined && secondDate !== undefined ) {
            var startDay = new Date(firstDate.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
            var endDay = new Date(secondDate.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));

            var millisBetween = startDay.getTime() - endDay.getTime();
            var days = millisBetween / (1000 * 3600 * 24);

            return Math.round(Math.abs(days));
        }

        return 0;
    }
});
